import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7b453dd8")
const _hoisted_1 = {
  key: 0,
  class: "base-modal"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1)
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Test")
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 1,
  class: "modal-footer"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "modal-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'times'],
                  size: "1x"
                })
              ]),
              (_ctx.header)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "header", {}, () => [
                      _hoisted_5
                    ], {}, true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]),
              (_ctx.footer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}